import React from 'react';
import {StyleSheet, TextStyle, View} from 'react-native';
import {observer} from 'mobx-react';

import Text from '../../components/ui-controls/Text';
import {useStores} from '../../stores/use-stores';
import {toAUD, toAUDAbs} from '../../utils/functions';

type TotalRowProps = {
  description: string;
  amount: number;
  isSigned?: boolean;
  isBold?: boolean;
};
const TotalRow = ({
  description,
  amount,
  isSigned = false,
  isBold = false,
}: TotalRowProps) => {
  const textStyle: TextStyle = {fontWeight: isBold ? 'bold' : 'normal'};
  return (
    <View style={orderTotalstyles.row}>
      <View style={orderTotalstyles.column}>
        <Text style={textStyle} align="right">
          {description}
        </Text>
      </View>
      <View style={orderTotalstyles.column}>
        <Text style={textStyle} align="right">
          {isSigned ? toAUD(amount, true) : toAUDAbs(amount, true)}
        </Text>
      </View>
    </View>
  );
};

const orderTotalstyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  column: {
    flex: 1,
  },
  amountBold: {
    fontWeight: 'bold',
  },
});

const OrderTotals = observer(() => {
  const {cartStore} = useStores();

  const subtotal = cartStore.getCartSubtotal();
  const gstIncluded = cartStore.getCartGstIncluded();
  const adjustments = cartStore.getCartAdjustments();
  const discountsAndCredits = cartStore.getCartDiscountsAndCredits();
  const total = cartStore.totalAmount;

  return (
    <View style={{width: 210, alignSelf: 'center'}}>
      <TotalRow description="Subtotal:" amount={subtotal} />
      <TotalRow description="GST included:" amount={gstIncluded} />
      {adjustments.map((adjustment: any) => (
        <TotalRow
          key={adjustment.name}
          description={adjustment.name}
          amount={adjustment.amount}
          isSigned
        />
      ))}
      {discountsAndCredits.map((discountOrCredit: any) => (
        <TotalRow
          key={discountOrCredit.name}
          description={discountOrCredit.name}
          amount={discountOrCredit.amount}
          isSigned
        />
      ))}
      <TotalRow description="Total:" amount={total} isBold />
    </View>
  );
});

export default OrderTotals;
